import { Form } from '@unform/web';
import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const Container = styled.section`
  max-width: 807px;
  max-height: 70.2rem;
  padding: 2.4rem;
  overflow-y: auto;

  /* &::-webkit-scrollbar {
    display: none;
  } */

  margin: 0 21% 0 0;
  background: #fff;
  border-radius: 0.6rem;

  @media (max-width: ${breakpoints.medium}) {
    margin: 1.6rem auto;
    width: 90%;
  }
`;

export const EditPackageTitle = styled.h2`
  font-size: 2.8rem;
  color: #0f0f0f;
  letter-spacing: 0.168rem;
  text-transform: uppercase;
`;

export const EditPackageHeader = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.4rem;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const EditPackageForm = styled(Form)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 2.4rem;
  column-gap: 6.4rem;

  @media (max-width: ${breakpoints.medium}) {
    display: flex;
    flex-direction: column;
  }
`;

export const EditPackageInputBlock = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > p {
    font-size: 1.4rem;
    opacity: 0.65;
    color: ${({ theme }) => theme.colors.black};
    user-select: none;
    padding: 0 0 0.6rem 1.2rem;
  }
`;

export const EditPackageFooter = styled.section`
  display: flex;
  justify-content: flex-start;
  margin-top: 3.2rem;
  gap: 1.6rem;
`;
